import { render, staticRenderFns } from "./ColumnViewBaseinfoBtn.vue?vue&type=template&id=4077e32f"
import script from "./ColumnViewBaseinfoBtn.vue?vue&type=script&lang=js"
export * from "./ColumnViewBaseinfoBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports